module.exports = __webpack_public_path__ + "static/media/lightbulb-dollar.8bbcef03.svg";